export default __webpack_public_path__ + "static/media/login_right.3006ef46.jpg";